import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export function useGetOrderPreCollectedTax(orderId: number) {
  return useQuery(['preCollectedTax', orderId], () =>
    axios.get<number>(`/api/orders/${orderId}/updated-tax`).then(({ data }) => data),
  );
}
